// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3xiDt","boxTitle":"Qualiphy_boxTitle__3N24K","box":"Qualiphy_box__2eBz4","toggleWrap":"Qualiphy_toggleWrap__2jy_k"};